module.exports = __webpack_public_path__ + "img/history.bbc40cee.png";